// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.location-edit-container {
  width: 400px;
}`, "",{"version":3,"sources":["webpack://./src/app/dialog/components/location-edit-dialog/location-edit-dialog.component.scss"],"names":[],"mappings":"AAAA;EACC,YAAA;AACD","sourcesContent":[".location-edit-container {\n\twidth: 400px;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
